module.exports = __webpack_public_path__ + "static/media/Screen_Shot_2.fe0af181.png";